import { useMemo } from 'react'
import { useAtomValueLoadable } from 'src/utils/jotai'
import { Colors, Shapes } from 'src/components/theme'
import { SVGUSAStatesHeatmap } from 'src/v2/components/svg-usa-states-heatmap'
import { styled, Typography } from '@mui/material'
import { FlexColumn } from 'src/components/flex-containers'
import { getPropertiesDistribution } from 'src/v2/utils/entity'
import { PropertiesDistributionTable } from 'src/v2/views/owner-reveal/sidebar/result-overlay/properties-distribution-table'

import * as atoms from 'src/v2/state/owner-reveal/sidebar'
import * as coreAtoms from 'src/v2/state/core'

const OwnerPortfolioContainer = styled(FlexColumn)`
  gap: ${Shapes.spacing[4]}px;
  padding: ${Shapes.spacing[5]}px ${Shapes.spacing[4]}px;
`

type OwnerPortfolioContentProps = {
  ownerId: string
}
const OwnerPortfolioContent = ({ ownerId }: OwnerPortfolioContentProps) => {
  const entity = useAtomValueLoadable(atoms.entityPreview(ownerId))

  const propertiesDistributions = useMemo(() => {
    if (!entity || entity.state !== 'hasData' || !entity.data) {
      return []
    }

    return getPropertiesDistribution(entity.data)
  }, [entity])

  if (entity.state !== 'hasData' || !entity.data) {
    return null
  }
  return (
    <OwnerPortfolioContainer>
      <SVGUSAStatesHeatmap
        title={
          <Typography variant="title2" color={Colors.neutral950}>
            Portfolio Breakdown
          </Typography>
        }
        data={entity.data.parcelsStateDistribution ?? {}}
        levels={[
          {
            color: Colors.redLight,
            percentage: 0.1,
          },
          {
            color: Colors.redMedium,
            percentage: 0.15,
          },
          {
            color: Colors.redDark,
            percentage: 0.2,
          },
          {
            color: Colors.redExtraDark,
            percentage: 0.25,
          },
        ]}
      />
      {propertiesDistributions.length > 0 && <PropertiesDistributionTable list={propertiesDistributions} />}
    </OwnerPortfolioContainer>
  )
}

export const OwnerPortfolio = () => {
  const selectedEntity = useAtomValueLoadable(coreAtoms.selectedEntity)
  const ownerId =
    selectedEntity.state === 'hasData' && selectedEntity.data?.type === 'SELECTED_OWNER' && selectedEntity.data.data.id
      ? selectedEntity.data.data.id
      : undefined

  if (!ownerId) {
    return null
  }

  return <OwnerPortfolioContent ownerId={ownerId} />
}
